// Shared event-date formatting for auras.
//
// Renders a single day, or a "<start> – <end>" range when the aura has an
// end_date (multi-day / vacation events).
//
// IMPORTANT: a "YYYY-MM-DD" string passed to `new Date(...)` is parsed as UTC
// midnight, which renders as the *previous* day in negative-UTC timezones. We
// parse the parts explicitly and build a local Date to avoid that off-by-one.

const LONG = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
const SHORT = { month: 'short', day: 'numeric', year: 'numeric' };

function parseLocal(dateString) {
  if (!dateString) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateString);
  if (!m) {
    const d = new Date(dateString);
    return isNaN(d) ? null : d;
  }
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

function fmt(dateString, opts) {
  const d = parseLocal(dateString);
  if (!d) return dateString || '';
  return d.toLocaleDateString('en-US', opts);
}

// formatEventDate(aura, { style: 'long' | 'short' })
// Accepts the aura object so callers don't have to thread end_date through.
export default function formatEventDate(aura, { style = 'long' } = {}) {
  if (!aura) return '';
  const opts = style === 'short' ? SHORT : LONG;
  const start = fmt(aura.event_date, opts);
  if (aura.end_date && aura.end_date !== aura.event_date) {
    return `${start} – ${fmt(aura.end_date, opts)}`;
  }
  return start;
}
